module.exports = __webpack_public_path__ + "static/media/mx.4e358e43.svg";